var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from './Icon/Icon';
import styled from 'styled-components';
import FlexBox from './Container/FlexBox';
const StyledListItem = styled(FlexBox) `
  gap: 8px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.11);
  width: 100%;
  padding: 4px 16px;
  height: 44px;
  cursor: pointer;
  overflow: hidden;
  &:hover {
    background: #f4f4f4;
  }
`;
const ListItemTitle = styled.span `
  color: #000;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
const ListItemIcon = styled.img `
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
`;
const Chip = styled.div `
  display: flex;
  padding: 4px 8px;
  align-items: center;
  border-radius: 4px;
  color: #000;
  background: #d7d7d7;
  height: 24px;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  span {
    max-width: 100px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;
const ListItem = (_a) => {
    var { title, tag, onClick } = _a, props = __rest(_a, ["title", "tag", "onClick"]);
    return (React.createElement(StyledListItem, { onClick: onClick },
        'imageUrl' in props && props.imageUrl && (React.createElement(ListItemIcon, { src: props.imageUrl })),
        'iconName' in props && (React.createElement(Icon, { name: props.iconName, color: "gray-40", size: "x-large" })),
        tag && (React.createElement(Chip, null,
            React.createElement("span", null, tag))),
        React.createElement(ListItemTitle, null, title)));
};
export default ListItem;
